import { render, staticRenderFns } from "./FormReview.vue?vue&type=template&id=7905d874&"
import script from "./FormReview.vue?vue&type=script&lang=js&"
export * from "./FormReview.vue?vue&type=script&lang=js&"
import style0 from "./FormReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports